module.exports = __webpack_public_path__ + "img/search-engines-amico.3fb451ce.svg";